"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            Areas: [
                'University',
                'High School',
                'Primary School',
                'Training Institute',
                'Research & Development',
                'Science & Technology',
                'LXP Tool Developers',
                'Other'
            ]
        };
        fhandler.bind(this, { areas: [] });
    },
    onInput: function (input) {
        input.reset && fhandler.reset();
    },
    onMount: function () {
        this.selected = this.state.form.areas;
    },
    onPrev: function () {
        this.emit('prev', this.input.index);
    },
    onNext: function () {
        window.onbehalfOf(window.uiStore.get('setup-institution').subdomain + '.' + window.location.host.replace(window.Defaults.domainAddon + '.', ''));
        this.emit('next', this.input.index, { areas: this.state.form.areas });
    },
    onSelect: function (name) {
        !this.selected.includes(name) ? this.selected.push(name) : this.selected = this.selected.filter(each => {
            return each !== name;
        });
        fhandler.set('areas', this.selected);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Areas.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Button_template = require("../../../../components/Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "w-100 p-lg-5 p-2"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("18b5b8"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/tags.png",
        alt: "areas",
        width: "60",
        "class": "mr-4"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "list-inline"
      },
    marko_node4 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "navigation-buttons"
      },
    marko_attrs5 = {
        "class": "btn btn-outline-primary btn-xl text-left d-inline-block"
      },
    marko_attrs6 = {
        "class": "btn btn-primary btn-xl text-left d-inline-block float-right w-50"
      },
    marko_attrs7 = {
        "class": "mr-1 my-25 "
      };

const fhandler = new FormHandler({ key: 'areas', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("h5", marko_attrs2, "3", component);

        out.n(marko_node0, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Which of these areas fit your institution?");
            }
          }, out, __component, "5");

        out.ee();

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        out.be("ul", marko_attrs3, "9", component);

        marko_forOf(state.Areas, function(area, index) {
          var $keyValue$0 = "@" + ("area-" + index),
              $keyScope$0 = "[" + ($keyValue$0 + "]");

          out.be("li", marko_attrs7, $keyValue$0, component);

          Button_tag({
              class: "btn btn-lg btn-outline-light",
              activeClass: "btn-outline-secondary btn-lg",
              state: state.form.areas.includes(area),
              renderBody: function(out) {
                Locale_tag({
                    text: area.toCapitalCase()
                  }, out, __component, "11" + $keyScope$0);
              }
            }, out, __component, "10" + $keyScope$0, [
            [
              "change",
              "onSelect",
              false,
              [
                  area
                ]
            ]
          ]);

          out.ee();
        });

        out.ee();

        out.ee();

        out.n(marko_node4, component);

        out.n(marko_node5, component);

        out.be("div", marko_attrs4, "14", component);

        out.be("button", marko_attrs5, "15", component, null, 0, {
            onclick: __component.d("click", "onPrev", false)
          });

        Locale_tag({
            text: "Back",
            class: "px-3"
          }, out, __component, "16");

        out.ee();

        out.be("button", marko_attrs6, "17", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "18");

        Locale_tag({
            text: "Continue"
          }, out, __component, "19");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
